import type { CreateProjectWithItemsParams, CreateProjectParams, HistoryResponse, GroupedRecommendItem } from '@/domains/project/types';
import { PsHttpService } from '@patsnap/tahiti-core';
import type { PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';

export interface SuggestApi {
    getHistoryItems(): Promise<HistoryResponse>;
    getClusteringItems(): Promise<GroupedRecommendItem[]>;
    createProjectWithItems(params: CreateProjectWithItemsParams): Promise<string>;
    createProject(params: CreateProjectParams): Promise<string>;
}

@injectable()
export class SuggestApiImpl extends PsHttpService implements SuggestApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/work/project`,
        }
    }

    getHistoryItems(): Promise<HistoryResponse> {
        return this.get<PatSnapCommonResponseData<HistoryResponse>>({
            url: '/item/recommend',
        }).then((res) => {
            return res.data as HistoryResponse;
        });
    }

    getClusteringItems(): Promise<GroupedRecommendItem[]> {
        return this.get<PatSnapCommonResponseData<GroupedRecommendItem[]>>({
            url: '/item/clustering',
        }).then((res) => {
            return res.data as GroupedRecommendItem[];
        });
    }

    createProjectWithItems(params: CreateProjectWithItemsParams): Promise<string> {
        return this.post<PatSnapCommonResponseData<string>>({
            url: '/create-with-items',
            data: params,
        }).then((res) => {
            return res.data as string;
        });
    }
}

export const SuggestApi = Symbol('SuggestApi');
